import { useStore } from '@/js/stores/index';

export function defaultConfirm(title: string, params = {
	image: null,
	imageInline: null,
	text: null,
	buttonText: null,
	buttonClass: null,

}){
	return new Promise(resolve => {
		const store = useStore()
		var html = ''
		
		if(params.image) html += '<img  class="modal-image" src="' + params.image + '" alt="">'
		else if(params.imageInline) html += params.imageInline

		html += '<div class="modal-title">' + title + '</div>'
		if(params.text) html += '<div class="modal-text">' + params.text + '</div>'

		window.$modalWrapper.exposed.openGenericModal(html,
			{
				buttonText: params.buttonText ? params.buttonText : store.translations?.genericYes,
				buttonCancelText: store.translations?.genericCancel,
				showCancel: true,
				buttonClass: params.buttonClass ? params.buttonClass : 'btn-primary',
				callback: resolve,
			}
		)
	})
}

export function defaultErrorModal(title, params = {
	image: null,
	imageInline: null,
	text: null,
	buttonText: null,
	buttonClass: null,
}){
	return new Promise(resolve => {
		var html = ""

		if(params.image) html += '<img  class="modal-image" src="' + params.image + '" alt="">'
		else if(params.imageInline) html += params.imageInline
		
		html += '<div class="modal-title">' + title + '</div>'
		if(params.text) html += '<div class="modal-text">' + params.text + '</div>'

		window.$modalWrapper.exposed.openGenericModal(html,
			{
				buttonText: params.buttonText ? params.buttonText : useStore().translations?.genericClose,
				buttonClass: params.buttonClass ? params.buttonClass : 'btn-default',
				callback: resolve,
			}
		)
	})
}

export function openAskNameModal(){
	window.$modalWrapper.exposed.openAskNameModal()
}

export function openWelcomeModal(){
	window.$modalWrapper.exposed.openWelcomeModal()
}

export function openGenericModal(html, params){
	window.$modalWrapper.exposed.openGenericModal(html, params)
}

// This helper compares query string of "from" and "to" routes, and returns if it was modal opening/closing
export function isModalToggling(fromQuery, toQuery){
	// Test for various examples we use across the app
	if(fromQuery.modal != toQuery.modal) return true;
	if(fromQuery.modalSms != toQuery.modalSms) return true;
	if(fromQuery.modalPhone != toQuery.modalPhone) return true;
	if(fromQuery.modalEmail != toQuery.modalEmail) return true;
	if(fromQuery.genericPopup != toQuery.genericPopup) return true;
	return false
}